import styled, { keyframes } from "styled-components";

import Backdrop from "components/global/Backdrop";

export const AllPostsWrapper = styled.div`
  width: 100%;

  .page-header {
    padding-inline: 24px;
  }

  .btn-container {
    position: relative;

    button {
      &:disabled:hover ~ .info {
        display: block;
      }
    }

    .info {
      width: 224px;
      position: absolute;
      background: var(--background);
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05),
        0px 25px 35px rgba(0, 0, 0, 0.03);
      border-radius: 4px;
      font-weight: 450;
      font-size: 14px;
      line-height: 18px;
      padding: 8px;
      right: 0;
      display: none;
      z-index: 4;
    }
  }

  .newPost {
    height: 40px;
    border-radius: 0.8rem;
    background-color: var(--secondary);
    padding: 10px 12px;
    transition: all 0.2s ease-out;
    gap: 4px;

    &:hover {
      background-color: var(--primary_light);
    }
  }

  .noPostFilter {
    position: absolute;
    width: min(417px, 100%);
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-70%, -30%);
    transform: translate(-70%, -30%);
    z-index: 1;
  }

  .postTab {
    position: sticky;
    top: 7.2rem;
    z-index: 4;
    padding-top: 0;
    background: #fff;
  }

  .loaderWrapper {
    margin: 0 24px;
  }

  @media screen and (max-width: 768px) {
    .postHeader {
      overflow: hidden;
    }

    .postTab {
      width: 100%;
      z-index: 3;
      top: 14.4rem;
    }

    .noPost {
      button {
        width: 100%;
      }

      .description {
        width: 100%;
      }
    }

    .noPostFilter {
      position: fixed;
      width: min(417px, 100%);
      left: 50%;
      top: 70%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      z-index: 1;
    }

    .newPost {
      position: fixed;
      bottom: 64px;
      right: 24px;
      z-index: 2;
      border-radius: 50%;
      height: 56px;
      width: 56px;
      padding: 0;
      justify-content: center;

      span {
        display: none;
      }
    }

    .title {
      font-size: 24px;
      line-height: 32px;
    }

    .description {
      font-size: 14px;
      line-height: 20px;

      &.emptyState {
        font-size: 16px;
      }
    }
  }
`;

export const AllPostsFilters = styled.div`
  flex-wrap: wrap;
  padding: 24px;
  align-items: center;

  .filtersWrapper {
    flex-wrap: wrap;
  }

  .create_post_btn_row {
    gap: 15px;
  }

  .filterItem {
    transition: color 0.2s ease-out;

    &:last-child {
      margin-right: 0;
    }

    &.active {
      color: var(--secondary);
    }
  }

  .divider {
    height: 3.6rem;
    width: 1px;
    background-color: var(--body_text);
  }

  .filterSelect {
    padding: 1.4rem;
    border: 1px solid var(--grey_10);
    border-radius: 0.8rem;
    height: 40px;
  }

  .selectCreator {
    width: max-content;

    .inputWrapper {
      padding: 1.4rem;
      border: 1px solid var(--grey_10);
      border-radius: 0.8rem;

      input {
        font-size: 14px;
        line-height: 16px;
      }

      input::placeholder {
        color: var(--body_text);
        font-size: 14px;
        line-height: 16px;
      }
    }

    .toggleIcon {
      filter: brightness(0) saturate(0);
    }
  }

  .select-channel {
    width: 200px;

    .inputWrapper {
      height: 40px;
    }

    .list {
      width: 240px;
      padding: 0 12px;
      box-shadow: 0px 0px 5px 0px #0000000d;
    }
  }

  .checkbox {
    width: 16px;
    height: 16px;
  }

  @media screen and (max-width: 768px) {
    gap: 1.2rem;

    .filtersWrapper {
      flex-wrap: nowrap;
      overflow-x: auto;
    }

    .select-channel {
      width: 200px;
      position: static;

      .inputWrapper {
        width: 200px;
      }
      .list {
        transform: translate(45%, 22%);
      }
    }

    .filterSelect,
    .clearFilter {
      padding: 1rem 1.6rem;
      height: fit-content;
    }

    .dateFilterWrapper {
      margin-left: auto;
    }
  }
`;

export const AllPostsPostGroup = styled.div`
  padding: 2.4rem;
`;

export const Tab = styled.div`
  background-color: #ffffff;
  border-bottom: 1px solid var(--grey_10);
  gap: 48px;
  padding-inline: 24px;
  height: 60px;

  .item {
    position: relative;
    cursor: pointer;

    &::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 0;
      height: 3px;
      border-radius: 3px;
      width: 100%;
      background-color: var(--secondary);
      opacity: 0;
      transition: opacity 0.2s ease-out;
    }

    &.active {
      .icon {
        filter: var(--filter_primary);
      }

      span {
        color: var(--secondary);
        font-weight: 700;
      }

      &::after {
        opacity: 1;
      }
      .count-tag {
        color: #fff;
      }
    }

    .count-tag {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 3px;
      background: #fd0403;
      color: #fff;
      font-size: 10px;
    }
  }

  @media screen and (max-width: 768px) {
    overflow-x: scroll;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    .item {
      border: 1px solid #fff;
      padding-right: 0;

      span {
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
`;

export const PostModalWrapper = styled(Backdrop)`
  opacity: 1;
  pointer-events: all;
`;

export const CreatePostWrapper = styled.div`
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  background-color: var(--white);
  border-radius: 16px;

  .draft-contentWrapper {
    border-right: 1px solid var(--grey_10);
    height: 100%;
    overflow: auto;
    width: 63%;

    .main-content {
      padding: 24px 24px 192px;
    }
  }

  .contentWrapper {
    padding: 24px 24px 192px;
    height: 100%;
    overflow: auto;
    width: 63%;
  }

  .selectSocialsRow {
    display: flex;
    align-items: flex-end;
    gap: 12px;

    .relatedPostsBtn {
      border-radius: 24px;
      border: 1px solid var(--grey_10);
      display: flex;
      padding: 10px 12px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
    }
  }

  .aiPreview {
    padding: 16px;
    height: 100%;
  }

  .imageCaptionMobile {
    display: none;
  }

  .characterCount {
    position: absolute;
    right: 0;
    top: 0;
    color: var(--body_text);
    line-height: 20px;
  }

  .mb {
    display: none;
  }

  .draft-preview {
    background: var(--background);
  }

  .actionCenterWrapper {
    width: 63%;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    border-radius: 0;

    .draft-contentWrapper {
      width: 100%;

      .main-content {
        padding: 12px 24px 192px;
      }
    }

    .header_content {
      gap: 16px;
      overflow: auto;
    }

    .contentWrapper {
      padding: 24px 24px 192px;
      width: 100%;
    }

    .actionCenterWrapper {
      width: 100%;
    }

    .imageCaptionMobile {
      display: block;
    }

    .title {
      font-size: 24px;
      line-height: 32px;
    }

    .mobileHeader {
      padding: 24px;
    }

    .mb {
      display: block;
    }

    .actionBtns {
      button {
        width: calc(50% - 0.6rem);
      }
    }

    .lg {
      display: none;
    }

    .mobileSpacer {
      margin-bottom: 5rem;
    }
  }
`;

export const EmptyState = styled.div`
  .content {
    width: min(417px, 100%);
    margin: auto;
    padding: 24px 0;
    color: var(--grey_1);
    text-align: center;
    font-weight: 450;
    font-size: 16px;
    line-height: 24px;
    color: var(--body_text);
  }

  .title {
    color: #07070c;
  }

  @media screen and (max-width: 768px) {
    .content {
      padding: 24px;
      font-weight: 450;
      font-size: 14px;
      line-height: 20px;
    }

    .title {
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
    }

    .description {
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
      line-height: 20px;
    }
  }
`;

export const CharacterLimitsWrapper = styled(Backdrop)`
  .card {
    width: 46.8rem;
    padding: 4.8rem;
    background-color: var(--white);
    border-radius: 0.8rem;
  }

  .socialIcon {
    height: 3.6rem;
  }

  .socialRow {
    margin-bottom: 1.2rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 2.4rem;
    font-weight: 450;
    .title {
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
    }

    .card {
      width: 100%;
      padding: 4.8rem 2.4rem;
    }

    .title {
      font-size: 18px;
      line-height: 20px;
    }

    .description {
      font-size: 14px;
      line-height: 20px;
    }

    .socialIcon {
      height: 2.4rem;
    }

    button {
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
    }
  }
`;

export const Attachments = styled.div`
  display: grid;
  position: relative;
  padding-inline: 16px;

  .fileInput {
    display: none;
  }

  .dropdown {
    position: absolute;
    width: 150px;
    bottom: 100%;
    left: 16px;
    z-index: 3;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05),
      0px 12px 20px 0px rgba(0, 0, 0, 0.03);

    .listItem {
      height: 40px;
      width: 100%;
      font-size: 14px;
      font-weight: 450;
      color: var(--grey_1);
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px;
      cursor: pointer;

      &:hover {
        background-color: var(--background);
      }
    }
  }

  .selectMediaWrapper {
    position: relative;
  }

  .chooseMedia {
    border-radius: 6px;
    border: 1px dashed var(--grey_10);
    width: 100%;
    padding: 24px 12px;
    min-width: 120px;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    transition: var(--transition_default);
    background-color: var(--white);

    &.dragActive {
      border-color: var(--secondary);
    }
  }

  .chooseMediaStory {
    height: 376px;
    border: 1px dashed var(--grey_10);
    border-radius: 6px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-style: normal;
      font-weight: 450;
    }

    &:hover {
      border-color: var(--secondary);
      color: var(--secondary);
      .storyIcon {
        filter: var(--filter_secondary);
      }
    }
  }

  .media_list_row {
    display: flex;

    &.disabled {
      pointer-events: none;
    }
  }

  .attached {
    overflow: ${({ hasOverflow }) => (hasOverflow ? "visible" : "auto")};
    margin-bottom: 12px;
    gap: 12px;

    &::-webkit-scrollbar {
      display: initial;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: var(--background);
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb {
      background: var(--grey_5);
      border-radius: 100px;
    }

    .mediafile_item {
      height: 12rem;
      aspect-ratio: 1/1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      border-radius: 0.3rem;
      background-color: var(--grey_1);
      margin-right: 1.2rem;
      position: relative;
      touch-action: pan-x;

      &:last-child {
        margin-right: 0;
      }

      .media {
        pointer-events: none;
        height: 100%;
        width: 100%;
        object-fit: contain;
      }

      .more_img_info {
        position: absolute;
        top: 0;
        width: 138px;
        left: 100%;
        padding: 4px;
        border-radius: 8px;
        background: #fff;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05),
          0px 12px 20px 0px rgba(0, 0, 0, 0.03);
        z-index: 7;

        button {
          width: 100%;
          text-align: left;
          font-size: 14px;
          font-weight: 450;
          height: 36px;
          padding: 8px;
          display: flex;
          align-items: center;
          gap: 8px;

          &.delete {
            color: #fd0403;
          }
        }
      }

      .more_btn {
        width: 20px;
        height: 20px;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 6px;
        right: 6px;
        z-index: 5;
        background: var(--grey_4);
        border-radius: 50%;
      }

      .indicator {
        position: absolute;
        height: 24px;
        aspect-ratio: 1/1;
        box-shadow: 0px 0px 3px var(--grey_9);
        transition: all 0.2s ease-out;
      }

      .indicator.remove {
        top: 6px;
        right: 6px;
        opacity: 0;
        background-color: var(--danger);
        z-index: 2;
      }

      .indicator.move {
        bottom: 6px;
        left: 6px;
        pointer-events: none;
        opacity: 0;
        z-index: 2;
      }

      .indicator.warning {
        position: absolute;
        top: 6px;
        left: 6px;
        background-color: var(--danger_light);
        width: 32px;
        height: 32px;
        border-radius: 50%;
        z-index: 5;
        cursor: pointer;

        &:hover {
          transform: scale(1.1);
        }
      }

      .indicator .icon {
        height: 60%;
      }

      .indicator.instaIndicator {
        bottom: 4px;
        right: 6px;
        cursor: pointer;
        box-shadow: none;
      }

      .indicatorWithTag {
        background-color: #07070ccc;
        min-width: 33px;
        height: 24px;
        padding: 3px;
        display: flex;
        align-items: center;
        border-radius: 24px;
      }

      .indicator.video {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        box-shadow: none;
      }

      .indicator.thumbnail-btn {
        position: absolute;
        top: 6px;
        right: 34px;
        background-color: var(--secondary);
        width: 24px;
        height: 24px;
        border-radius: 50%;
        z-index: 5;
        cursor: pointer;
        transition: transform 0.2s ease-out;

        &:hover {
          transform: scale(1.1);
        }

        .icon {
          height: 14px;
          width: 14px;
        }

        .thumbnail-set-indicator {
          position: absolute;
          top: -2px;
          right: -2px;
          width: 8px;
          height: 8px;
          background-color: var(--success);
          border-radius: 50%;
          border: 1px solid white;
        }
      }

      video {
        height: 100%;
        aspect-ratio: 1/1;
      }

      .loader {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        z-index: 1;
        background-color: rgba(0, 0, 0, 0.3);
        display: none;
      }

      .retryBtn {
        gap: 6px;
        padding: 6px;
        border-radius: 8px;
        background-color: #ffffff;
      }

      &[data-loaded="false"] {
        .loader {
          display: flex;
        }

        .index {
          display: none;
        }
      }

      &:hover .indicator.move,
      &:hover .indicator.remove {
        opacity: 1;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .attached {
      align-items: ${({ hasOverflow }) =>
        hasOverflow ? "flex-start" : "center"};
      flex-direction: ${({ hasOverflow }) => (hasOverflow ? "column" : "row")};
    }
  }
`;

export const Socials = styled.div`
  display: flex;
  gap: 12px;

  .platformWrapper {
    position: relative;
    gap: 6px;

    .platformCheckIcon {
      position: absolute;
      left: 0;
      top: 0;
      pointer-events: none;
    }

    .check {
      height: 2.4rem;
      opacity: 0;
      pointer-events: none;

      &.show {
        opacity: 1;
        pointer-events: all;
      }
    }

    .platformBtn {
      height: 40px;
      width: 40px;

      // .platformImg {
      //   height: 100%;
      //   width: 100%;
      //   left: 2.4rem;
      // }

      &:hover {
        box-shadow: 0px 0px 2px var(--grey_9);
      }

      &:disabled {
        pointer-events: none;
        opacity: 0.4;
      }
    }
  }

  .selectPostType {
    gap: 3px;
    background-color: var(--off_white);
    border-radius: 8px;
    padding: 3px 6px;
    height: max-content;
  }

  .postTypeOptions {
    position: absolute;
    top: calc(100% + 12px);
    left: 0;
    box-shadow: var(--shadow);
    border-radius: 8px;
    background-color: #ffffff;
    z-index: 30;
    opacity: 0;
    pointer-events: none;
    transition: all 0.2s ease-out;

    &.show {
      opacity: 1;
      pointer-events: all;
    }

    .option {
      width: 100%;
      padding: 12px;
      transition: all 0.2s ease-out;

      &:hover {
        background-color: var(--background);
      }
    }
  }

  .selectAccountsDropdown {
    position: absolute;
    top: calc(100% + 12px);
    left: 0;
    z-index: 30;
    background-color: var(--white);
    box-shadow: var(--shadow);
    border-radius: 0.8rem;
    padding-top: 12px;
    width: 250px;
    max-height: 312px;
    overflow: auto;
    opacity: 0;
    pointer-events: none;
    transition: all 0.2s ease-out;

    .dropdownTitle {
      margin-left: 12px;
    }

    .doneBtnWrapper {
      position: sticky;
      bottom: 0;
      padding: 12px;
    }

    .doneBtn {
      height: 4.8rem;
      margin-left: auto;
    }

    .checkBox {
      padding: 12px;
      transition: all 0.2s ease-out;

      label {
        line-height: 24px;
      }

      &:hover {
        background-color: var(--background);
      }
    }

    &.show {
      opacity: 1;
      pointer-events: all;
    }
  }

  .not-connected {
    position: relative;
    padding: 8px;
    border: 1px solid var(--grey_10);
    border-radius: 50%;
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 100%;
    }

    svg {
      position: absolute;
      bottom: 0;
      right: 0;
      border-radius: 50%;
      background-color: var(--off_white);
    }

    &.add-brand {
      svg {
        position: relative;
        right: unset;
        bottom: unset;
        background-color: inherit;
      }
    }

    &:hover {
      border-color: var(--secondary);

      svg path {
        fill: var(--secondary);
      }
    }
  }

  @media screen and (max-width: 768px) {
    gap: 8px;

    .selectAccountsDropdown,
    .postTypeOptions {
      max-height: 60vh;
      overflow: auto;
      position: fixed;
      bottom: unset;
      width: calc(100vw - 48px);
      margin: auto;
      left: 24px;
      top: 30vh;
    }
  }
`;

export const PreviewTab = styled.div`
  display: flex;
  gap: 24px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 5px;

  &::-webkit-scrollbar {
    display: initial;
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: var(--background);
    border-radius: 100px;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--grey_5);
    border-radius: 100px;
  }

  .item {
    height: 40px;
    min-width: 40px;
    max-width: 40px;
    background-color: #c6cbd9;

    img {
      height: 100%;
    }
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NoPostPreview = styled.div`
  width: 100%;
  max-width: 336px;

  img {
    width: 100%;
  }
`;

export const PlatformPreviewWrapper = styled.div`
  padding: 48px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const PostTitleWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: auto 48px;
  grid-gap: 24px;
  padding: 16px;
  border-bottom: 1px solid var(--grey_10);

  input {
    display: block;
    background-color: transparent;
    border: none;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
`;

export const PostPlatformTabs = styled.div`
  box-sizing: border-box;
  display: flex;
  gap: 6px;
  max-width: 100%;
  margin-bottom: -1px;
  padding: 8px 26px 0 18px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  & > div {
    flex: 0 0 auto;
  }

  .platform {
    min-width: 40px;
    height: 32px;
    border-radius: 8px 8px 0px 0px;
    border: 1px solid #e2e2ea;
    border-bottom: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--off_white);
    position: relative;

    &.active {
      background-color: var(--white);
    }
  }

  .platform-error {
    border-radius: 50%;
    background-color: #672d12;
    position: absolute;
    padding: 2px;
    bottom: 3px;
    right: 2px;
  }

  .platformWarningIcon {
    position: absolute;
    top: -8px;
    right: -8px;
    background-color: white;
    border-radius: 50%;
  }

  .tooltip {
    position: relative;
    display: inline-block;

    .tooltiptext {
      visibility: hidden;
      max-width: 194px;
      width: max-content;
      background-color: var(--grey_1);
      color: #fff;
      text-align: left;
      border-radius: 6px;
      padding: 12px;
      position: absolute;
      z-index: 1;
      font-size: 12px;
      font-style: normal;
      font-weight: 450;
      line-height: 16px;
      top: -150%;
      right: -45px;
      margin-left: -60px;
    }

    .tooltiptext::after {
      content: "";
      position: absolute;
      margin-top: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent transparent black;
      top: 100%;
      left: 50%;
      margin-left: -5px;
    }
  }

  .hasError:hover .tooltiptext {
    visibility: visible;
  }
`;

export const PostContentWrapper = styled.div`
  border: 1px solid #e2e2ea;
  border-radius: 8px;
  position: relative;
  margin-top: ${({ $hasPlatformTabs }) => ($hasPlatformTabs ? "0" : "24px")};

  .post-type {
    position: relative;
    border-bottom: 1px solid var(--grey_10);
    padding: 18px;
    height: 52px;
    display: flex;
    align-items: center;
    gap: 24px;

    label {
      margin-left: 0.6rem;
    }

    .radioBtn {
      height: 100%;
      aspect-ratio: 1 / 1;

      &::after {
        height: 9px;
        width: 9px;
      }
    }
  }

  .inputArea {
    padding: 16px 16px;
    border: none;
    overflow: auto;
    position: relative;
    margin-bottom: 24px;
  }

  .contentWarning {
    background-color: #ffe3d5;
    padding: 6px 12px;
    border-radius: 4px;
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 450;
    line-height: 20px;
  }

  .contentDefault {
    background-color: var(--off_white);
    padding: 6px 12px;
    border-radius: 4px;
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 450;
    line-height: 20px;
  }

  .content-warning-yellow {
    background: #fffae5;
  }

  .failedPostWarning {
    font-size: 14px;
    font-weight: 450;
    line-height: 18px;
    color: #fd0403;
    background: #ffeded;
    border-radius: 6px;
    padding: 6px 12px;
    word-break: break-all;
    word-wrap: break-word;
    margin-bottom: 12px;
  }

  .fieldWrapper {
    height: max-content;
    display: grid;

    textarea {
      display: block;
      color: ${(props) => props.color ?? "var(--grey_1)"};
      width: 100%;
      min-height: 100px;
      background-color: transparent;
      border: none;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      position: relative;
      z-index: 2;
      overflow: hidden;
      grid-area: 1 / 1 / 2 / 2;

      &::placeholder {
        color: var(--grey_8);
        font-size: 14px;
        font-weight: 450;
        line-height: 20px;
      }
    }
  }

  .formattedText {
    position: relative;
    width: 100%;
    min-height: 100px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    color: transparent;
    white-space: pre-wrap;
    grid-area: 1 / 1 / 2 / 2;
    word-break: break-word;

    .highlighted {
      display: inline-block;
      color: var(--secondary);
      position: relative;
      z-index: 3;

      &:hover .tooltiptext {
        visibility: visible;
      }
    }

    .extraText {
      position: absolute;
      bottom: 0;
      background-color: var(--danger_light);
      width: 100%;
    }

    .unshorten-tooltip {
      position: relative;

      .tooltiptext {
        z-index: 15;
        visibility: hidden;
        max-width: 194px;
        width: max-content;
        background-color: var(--grey_1);
        color: #fff;
        text-align: left;
        border-radius: 6px;
        padding: 6px;
        position: absolute;
        font-size: 12px;
        font-style: normal;
        font-weight: 450;
        line-height: 16px;
        top: 70%;
        right: 0;
        left: 60%;
        margin-left: -60px;
      }

      .tooltiptext::after {
        content: "";
        position: absolute;
        top: -8%;
        left: 45%;
        width: 10px;
        height: 10px;
        background-color: #000;
        transform: rotate(45deg);
      }
    }

    .dropdownContainer {
      position: relative;
    }

    .dropdown {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 10;
      background-color: #fff;
      border-radius: 8px;
      padding: 8px;
      width: 100%;
      min-width: 280px;
      max-height: 200px;
      overflow-y: auto;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05),
        0px 25px 35px 0px rgba(0, 0, 0, 0.03);
      display: flex;
      flex-direction: column;
      gap: 6px;

      .dropdownContent {
        display: flex;
        padding: 8px 12px;
        align-items: center;
        gap: 8px;
        border-radius: 8px;
        font-size: 14px;
        color: #07070c;

        &:hover {
          background: #f2f2f2;
        }

        .contentBody {
          display: flex;
          flex-direction: column;
          gap: 2px;

          div {
            display: flex;
            justify-content: space-between;
            gap: 8px;
            align-items: center;
            color: #656575;
          }
        }

        .avatar {
          .social-icon {
            padding: 2px;
            width: 20px;
            height: 20px;
            right: 0;
          }
        }
      }
    }

    .button-hidden {
      display: none;
    }
  }

  .action-container {
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    max-width: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 52px;
    z-index: 2;
    background-color: #ffffff;
    align-items: center;
    padding: 16px;

    .platformActions {
      gap: 24px;
    }

    .threadBtn {
      display: flex;
      gap: 3px;
      align-items: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
      color: var(--secondary);
    }
  }

  .emojiBtn {
    height: 2.4rem;
    gap: 4px;
    font-size: 12px;
    font-weight: 500;

    &.firstCommentEmoji {
      width: 2.4rem;
    }
  }

  .divider {
    height: 13px;
    width: 1px;
    background: #e2e2ea;
  }

  .tooltip {
    .tooltiptext {
      top: -45px;
      right: -110%;
    }

    .tooltiptext::after {
      left: 45%;
      margin-top: 4px;
      border-width: 5px;
      border-style: solid;
      border-color: black transparent transparent transparent;
    }

    &:hover .tooltiptext {
      visibility: visible;
    }
  }

  .instagramExtend {
    display: ${({ platform, postType }) =>
      platform === "instagram" && postType !== "story" ? "block" : "none"};
    border-top: 1px solid var(--grey_10);

    .instaInputArea {
      display: grid;
      grid-template-columns: 1fr 4fr;
      gap: 10px;
      padding: 10px 10px;
      border: none;
      overflow: auto;
      position: relative;

      .inputContainer {
        display: flex;
        align-items: center;
        border: 1px solid var(--grey_10);
        border-radius: 6px;
        background-color: #fafafa;

        .searchInput {
          border: none;
          padding: 10px;
          border-radius: 6px;
          flex: 1;
          background-color: #fafafa;
          &::placeholder {
            color: #7e7e8f;
          }
        }

        .emojiContainer {
          border-left: 1px solid var(--grey_10);
          height: 100%;
          padding: 10px;
        }

        .emojiArea {
          width: 20px;
          height: 20px;
          background: #fff;
          margin-right: 10px;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .instaInputArea {
      grid-template-columns: 1fr;
    }

    .emojiBtn {
      span {
        display: none;
      }
    }

    .start-thread {
      display: none;
    }

    .fieldWrapper {
      textarea {
        font-size: 14px;
        font-style: normal;
        font-weight: 450;
        line-height: 20px;
      }
    }

    .formattedText {
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
      line-height: 20px;
    }
  }
`;

export const FileInfo = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2.4rem;
  background-color: #00000090;
  color: #ffffff;
  padding: 0.2rem 0.6rem;

  .fileName {
    width: 99%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 8px;
    line-height: 8px;
    margin-bottom: 2px;
  }

  .fileSize {
    font-size: 7px;
    line-height: 7px;
  }
`;

export const ActionCenterWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  border-top: 1px solid var(--grey_10);
  padding: 24px;
  width: 100%;
  z-index: 10;
  background-color: #ffffff;

  .tooltip {
    position: relative;
    display: inline-block;

    .tooltiptext {
      visibility: hidden;
      max-width: 194px;
      width: max-content;
      background-color: var(--grey_1);
      color: #fff;
      text-align: left;
      border-radius: 6px;
      padding: 12px;
      position: absolute;
      z-index: 1;
      top: -2px;
      right: 110%;
      font-size: 12px;
      font-style: normal;
      font-weight: 450;
      line-height: 16px;
    }

    .tooltiptext::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 100%;
      margin-top: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent transparent black;
    }

    &:hover .tooltiptext {
      visibility: ${({ hasToolTip }) => (hasToolTip ? "visible" : "hidden")};
    }
  }

  .dropdown-btn-wrapper {
    position: relative;
    width: 40px;
    height: 48px;
  }

  .dropdownWrapper .dropdown {
    position: absolute;
    bottom: calc(100% + 12px);
    right: 0;
    width: 100%;
    background: #fff;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05),
      0px 25px 35px rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    padding: 12px 0;
    font-weight: 450;
    font-size: 14px;
    line-height: 18px;

    .list-item {
      width: 100%;
      padding: 12px;
      display: flex;
      align-items: center;
      gap: 9px;
      background-color: inherit;
      color: var(--grey_1);

      &:hover {
        cursor: pointer;
        background: var(--background);
      }

      &:disabled {
        opacity: 0.5;
        cursor: auto;
      }

      img {
        filter: brightness(50%);
      }
    }
  }

  .dropdown-list-new {
    position: absolute;
    bottom: calc(100% - 12px);
    right: 24px;
    width: 196px;
    background: #fff;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05),
      0px 25px 35px rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    padding: 12px;
    font-weight: 450;
    font-size: 14px;
    line-height: 18px;

    .list-item {
      padding: 12px;
      display: flex;
      display: grid;
      grid-template-columns: 20px auto;
      text-align: left;
      align-items: center;
      gap: 9px;
      color: black;

      &:hover {
        cursor: pointer;
        background: var(--background);
      }

      img {
        filter: brightness(50%);
      }
    }

    @media screen and (max-width: 768px) {
      right: 30px;
      bottom: 90px;
      overflow: hidden;
      position: fixed;
    }
  }

  .buttonContainer {
    display: flex;
    align-items: center;
    border: none;
    border-radius: 8px;
    color: white;
    font-size: 14px;
    cursor: pointer;

    .text {
      gap: 4px;
      color: #fff;
      border-right: 1px solid #ffffff;
      width: 100%;
      height: 100%;
      padding: 9px;
      border-radius: 8px 0 0 8px;
      background-color: var(--secondary);
    }
  }

  .dropdown-button-new {
    position: relative;
    width: 40px;
    height: 100%;

    .caret {
      padding: 8px;
      height: 100%;
      width: 100%;
      background-color: var(--secondary);
      border-radius: 0 8px 8px 0;
    }
  }

  .buttonIcon {
    filter: invert(1);
    transform: rotate(180deg);
  }

  .has_approval_create_draft_btn {
    display: flex;
    height: 48px;

    &:hover button {
      background: var(--primary_light);
    }

    &:hover .scheduleBtn {
      background: #fff;
    }

    &:hover .dropdownBtn {
      background: #fff;
    }

    .scheduleBtn {
      border: 1px solid var(--grey_10);
      background-color: #fff;
      color: var(--grey_1);

      .caret {
        filter: invert(0);
      }
    }

    .dropdownBtn {
      border: 1px solid var(--grey_10);
      border-left: none;
      background-color: #fff;
      color: var(--grey_1);

      .caret {
        filter: invert(0);
      }
    }

    button {
      background-color: var(--secondary);
      color: #fff;
      height: 100%;
      padding: 14px 12px;
      display: flex;
    }

    .btn_text_section {
      gap: 4px;
    }
  }

  .optionsBtn {
    min-width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0px 8px 8px 0px;
    border-left: 1px solid #61bdff;

    .caret {
      filter: invert(1);
      transform: rotate(180deg);
    }
  }

  .has_approval_schedule_draft_btn,
  .no_teamPlan_edit_save_draft_btn {
    border-radius: 8px 0px 0px 8px;
    gap: 4px;
    display: flex;
    align-items: center;
  }

  .no_teamPlan_save_draft_btn {
    border-radius: 8px;
  }

  .actionBtns {
    margin-left: auto;
    gap: 12px;
    flex-wrap: nowrap;

    button {
      font-size: 14px;
      font-weight: 450;
    }
  }

  .failedPost-btns {
    display: flex;
    float: right;

    .resend:hover img {
      -webkit-filter: invert(100%);
      filter: invert(100%);
    }
  }

  .scheduleTimeContainer {
    display: none;
    margin-bottom: 12px;

    .schedule-container {
      min-width: 100%;
      border-radius: 8px;
      padding: 6px;
      align-items: center;
      font-size: 12px;
      font-weight: 450;
      gap: 6px;
    }

    .scheduled {
      color: #027a48;
      background: #ecfdf3;
    }

    .unscheduled {
      background: var(--off_white);
    }

    .overdue {
      background: #ffebeb;
      color: #fd0403;
    }
  }

  .editDraftSaveChanges {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background-color: var(--secondary);
    border-radius: 8px;
    padding: 14px 12px;
    gap: 4px;
    color: #ffffff;
  }

  .editScheduleDraftBtn {
    border-radius: 8px;
    padding: 14px 12px;
    gap: 4px;
    height: 48px;
    border: 1px solid var(--grey_10);
  }

  .privilegeBtnWrapper {
    justify-content: space-between;
  }

  @media screen and (max-width: 768px) {
    padding: 4px 24px;
    position: fixed;

    .tooltip {
      width: 100%;
      .tooltiptext {
        top: -150%;
        right: 0;
        margin-left: -60px;
      }

      .tooltiptext::after {
        top: 100%;
        left: 50%;
        margin-top: -5px;
        margin-left: -5px;
      }
    }

    .actionBtns {
      flex-direction: ${({ isDraftEdit, isRow }) =>
        isDraftEdit && !isRow ? "row" : "row"};
      margin-left: ${({ isDraftEdit, isRow }) =>
        isDraftEdit && isRow ? "0px" : "0px"};

      button {
        width: 100%;
      }
    }

    .dropdown-btn {
      min-width: 44px;
    }

    .scheduleTimeContainer {
      display: block;
    }

    .buttonContainer {
      height: 48px;

      .dropdown-button-new {
        height: 48px;
      }
    }

    .privilegeBtnWrapper {
      gap: 24px;
      width: 100%;

      .editScheduleDraftBtn {
        flex: 1;
        width: fill-available;
      }
    }
  }
`;

const slide = keyframes`
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%)translateX(-2px);
  }
`;

export const ReelPreview = styled.div`
  width: 100%;
  max-width: 336px;
  padding: 24px 12px;
  aspect-ratio: 9 / 16;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  background-color: black;
  position: relative;
  overflow: hidden;
  border: 1px solid var(--grey_10);
  border-radius: 8px;
  box-shadow: var(--shadow);

  .topText {
    position: absolute;
    top: 10px;
    left: 100px;
    z-index: 2;
  }

  .video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    filter: brightness(0.8);
  }

  .reelContent {
    max-width: 253px;
    position: relative;
    pointer-events: none;
    z-index: 2;
  }

  .header {
    gap: 6px;
  }

  .audio {
    height: 28px;
    width: 120px;
    position: relative;
    display: grid;
    grid-template-columns: 16px 92px;
    grid-gap: 6px;
    align-items: center;
    border-radius: 100px;

    &[data-platform="facebook"] {
      padding: 6px 0px 6px 6px;
      background-color: rgba(255, 255, 255, 0.3);
    }

    .track {
      flex-wrap: nowrap;
      overflow: hidden;
    }
  }

  .audioTitle {
    font-size: 10px;
    animation: ${slide} 5s linear infinite;
  }

  .actionBtns {
    width: 20px;
    position: relative;
    pointer-events: none;
    z-index: 2;
    gap: 24px;

    .group {
      gap: 3px;
    }

    .profilePictureSquare {
      border-radius: 2px;
      border: 1px solid #ffffff;
    }
  }

  .textSub {
    font-size: 10px;
    line-height: 12px;
  }

  .subscribe {
    padding: 3px 6px;
    gap: 8px;
    background-color: #b80000;
  }

  .play-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 12px;
    border-radius: 100%;
    z-index: 1;
  }
`;

export const PreviewContainer = styled.div`
  width: 37%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: var(--background);

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const PostBannerWrapper = styled.div`
  padding: 2.4rem;
  border: 1px solid var(--grey_10);
  border-radius: 0.8rem;
  transition: var(--transition_default);
  position: relative;
  background-color: var(--white);

  .btn {
    &.edit {
      border-color: #e2e2ea;
    }

    &:hover {
      color: #fff;
    }
  }

  .contentContainer {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    width: 100%;
    max-height: 120px;

    .withMedia {
      display: grid;
      grid-template-columns: 1fr 8fr;
      gap: 24px;
      width: 100%;
    }

    .withoutMedia {
      display: grid;
      grid-template-columns: 1fr;
      gap: 24px;
      width: 100%;
    }

    .mediaLength {
      position: absolute;
      top: 80%;
      left: 25px;
      border-radius: 4px;
      background-color: #07070ccc;
      padding: 5px;
      width: 32px;
      height: 32px;
    }

    .imageContainer {
      position: relative;
      .img {
        height: 120px;
        width: 120px;
        border-radius: 8px;
      }
    }

    .videoContainer {
      position: relative;
      height: 120px;
      width: 120px;

      .video {
        height: 120px;
        width: 120px;
        object-fit: cover;
        border-radius: 8px;
      }

      .videoIndicator {
        position: absolute;
        z-index: 2;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 48px;
        height: 48px;
      }
    }
  }

  .captionWrapper {
    width: 100%;
  }

  .caption {
    max-width: 100%;
    overflow-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 100%;

    .truncated {
      display: none;
    }

    .full {
      display: inline;
    }

    &.truncate {
      .truncated {
        display: inline;
      }

      .full {
        display: none;
      }
    }
  }

  .hashtags {
    max-width: 70%;
  }

  .optionBtn {
    position: relative;

    .icon {
      width: 2rem;
    }
  }

  .dateTime {
    height: max-content;
  }

  .time {
    color: #474848;
  }

  .switch-icon {
    margin-left: 12px;
  }

  .timezone {
    max-width: 160px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left: 2.4rem;
  }

  .status {
    gap: 4px;
    border-radius: 16px;
    height: 20px;
    padding: 2px 8px;

    .dot {
      height: 8px;
      width: 8px;
      border-radius: 100%;
    }

    &.published {
      background-color: var(--success_light);
      color: var(--success);

      .dot {
        background-color: var(--success);
      }
    }

    &.pending {
      background-color: var(--warning_light);
      color: var(--warning_dark);

      .dot {
        background-color: var(--warning);
      }
    }

    &.failed {
      background-color: var(--danger_light);
      color: var(--danger);

      .dot {
        background-color: var(--danger);
      }
    }
  }

  .socialRow {
    gap: 1.2rem;
  }

  .socialIcon {
    height: 2.4rem;
  }

  .imgWrapper {
    height: 2.4rem;
    width: 2.4rem;
    overflow: hidden;
    margin-right: 1.2rem;

    &:last-child {
      margin-right: 0;
    }

    img {
      height: 100%;
    }
  }

  .creator-container {
    gap: 6px;
    font-weight: 450;
    font-size: 12px;
    grid-column: 1 / 3;

    .created-title {
      color: var(--grey_6);
    }

    .creator-image {
      border-radius: 50%;
    }
  }

  .postCardOptionsWrapper {
    position: relative;

    .postCardOptionsBtn {
      height: 36px;
      width: 36px;
      border: 1px solid var(--grey_10);
      border-radius: 8px;
    }

    .optionsDropdown {
      position: absolute;
      right: 0;
      top: 40px;
      width: 160px;
      padding: 8px 0;
      border-radius: 8px;
      background: #fff;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05),
        0px 25px 35px 0px rgba(0, 0, 0, 0.03);
      z-index: 5;

      button {
        height: 44px;
        padding: 12px;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        font-weight: 450;
        width: 100%;

        &.delete {
          color: var(--danger);
        }
      }
    }
  }

  .duplicateBtn {
    gap: 8px;
    border: 1px solid var(--grey_10);
    height: 36px;
    padding: 8px;
    border-radius: 8px;
  }

  .options {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
    background-color: #ffffff;
    gap: 2.4rem;
    width: 100%;
    padding: 1.2rem 2.4rem;
    padding-top: 0;
    opacity: 0;
    pointer-events: none;
    transition: var(--transition_default);

    &.show {
      opacity: 1;
      pointer-events: all;
    }
  }

  .btn {
    padding: 8px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    gap: 8px;
  }

  .deleteBtn {
    background-color: var(--danger);
  }

  &.mb {
    display: none;
  }

  @media screen and (max-width: 768px) {
    padding: 1.2rem;

    .edit {
      background: #fff;
      border: 1px solid #e2e2ea;
      height: 36px;
      width: 36px;
      border-radius: 8px;
    }

    .duplicateBtn {
      width: 36px;
      height: 36px;
    }

    .captionWrapper {
      width: 100%;
    }

    .caption {
      max-width: 100%;
      font-size: 14px;
      line-height: 18px;
    }

    .hashtags,
    .time {
      font-size: 12px;
      line-height: 16px;
    }

    .socialRow {
      gap: 3px;
    }

    .socialIcon {
      margin-left: -5px;

      &:first-child {
        margin-left: 0;
      }
    }

    .creator-container {
      gap: 14px;
    }

    .creator-image {
      border-radius: 50%;
    }

    .mediaLength {
      position: absolute;
      width: 32px;
      height: 32px;
      top: 80%;
      left: 25px;
      border-radius: 4px;
      background-color: #07070ccc;
      padding: 5px;
      width: 32px;
      height: 32px;
    }

    .post-extras {
      .imageContainer {
        position: relative;
        .img {
          height: 120px;
          width: 120px;
          border-radius: 8px;
        }
      }

      .videoContainer {
        position: relative;
        height: 120px;
        width: 120px;

        .video {
          height: 120px;
          width: 120px;
          object-fit: cover;
          border-radius: 8px;
        }

        .videoIndicator {
          position: absolute;
          z-index: 2;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    .client {
      .clientName {
        width: 54px;
      }
    }

    &.lg {
      display: none;
    }

    &.mb {
      display: block;
    }

    .btn-text {
      display: none;
    }

    .options {
      padding: 12px;
    }
  }
`;

export const QueuedPostsWrapper = styled.div`
  background-color: #fff;
  display: grid;
  grid-template-columns: auto 340px;
  height: calc(100vh - 144px);
  width: 100%;
  overflow: auto;

  .queued-posts {
    position: relative;
    height: 100%;
    overflow: auto;

    .header {
      width: 100%;
    }
  }

  .queued-posts .header {
    background: #fff;
    padding: 24px;
    position: sticky;
    z-index: 3;
    top: 0;

    .add_to_queue_dropdown_wrapper {
      position: relative;
    }

    .add_to_queue_btn {
      height: 36px;
      padding: 14px 12px;
      border-radius: 8px 0px 0px 8px;
      background: var(--secondary);
      gap: 4px;
      color: #fff;
      font-size: 14px;
    }

    .dropdown_btn {
      height: 36px;
      border-radius: 0px 8px 8px 0px;
      border-left: 1px solid #61bdff;
      background: var(--secondary);
      display: flex;
      padding: 14px 12px;
      justify-content: center;
      align-items: center;
    }

    .add_to_queue_dropdown {
      position: absolute;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05),
        0px 25px 35px rgba(0, 0, 0, 0.03);
      background-color: #fff;
      right: 0;
      top: calc(100% + 5px);
      width: 207px;
      border-radius: 16px;

      .list_item {
        padding: 12px;
        font-size: 14px;
        font-weight: 450;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;

        &:hover {
          background-color: var(--background);
        }
      }
    }

    button {
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
    }

    .settings-btn {
      border: 1px solid var(--grey_10);
      border-radius: 8px;
      height: 36px;
      width: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      display: none;
    }

    .brand-socials {
      gap: 24px;
      height: 36px;
      width: 200px;
    }

    .select-channel {
      width: 100%;

      .inputWrapper {
        height: 36px;
      }
    }

    .channel-wrapper {
      gap: 12px;
      cursor: pointer;
      height: 48px;

      .platformImg {
        left: unset;
        right: -5px;
      }

      .channel-name {
        max-width: 120px;
      }
    }

    .action-btns {
      gap: 12px;

      button {
        padding: 8px;
        border-radius: 8px;
        display: flex;
        height: 36px;
        min-width: 78px;
        gap: 6px;
        align-items: center;
        justify-content: center;
        border: 1px solid var(--grey_10);
      }

      .btn_icon {
        display: none;
      }
    }
  }

  .loaderWrapper {
    margin: 24px;
  }

  .queuedPostList {
    padding: 24px;
  }

  .mobile-btn-container {
    display: none;
    position: fixed;
    bottom: 60px;
    right: 24px;
    z-index: 5;
    gap: 12px;
    display: flex;
    flex-direction: column-reverse;

    button {
      border-radius: 50%;
      height: 48px;
      width: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0px 25px 35px 0px rgba(0, 0, 0, 0.03),
        0px 0px 5px 0px rgba(0, 0, 0, 0.05);
    }

    .post-btn {
      background-color: var(--secondary);
      display: none;
    }

    .queue-btn {
      background-color: var(--secondary);
    }

    .multipostAdd-btn {
      border: 1px solid var(--grey_10);
      background-color: #ffffff;
    }

    .save-btn {
      background-color: var(--primary);

      .icon {
        -webkit-filter: invert(100%);
        filter: invert(100%);
      }
    }

    .cancel-btn {
      background-color: #fff;
      border: 1px solid var(--grey_10);
    }
  }

  @media screen and (max-width: 768px) {
    height: calc(100vh - 216px);
    grid-template-columns: 1fr;

    .mobile-btn-container {
      display: flex;

      .post-btn {
        display: flex;
      }
    }

    .queue_config_section {
      display: none;
    }

    .queued-posts {
      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }

      .header {
        .add_to_queue_dropdown_wrapper {
          display: none;
        }

        .action-btns {
          button {
            min-width: max-content;
          }

          .btn_icon {
            display: block;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .btn_text {
            display: none;
          }
        }

        .settings-btn {
          display: flex;
        }
      }
    }
  }
`;

export const FailedPostsWrapper = styled.div`
  height: calc(100vh - 144px);
  width: 100%;
  overflow: auto;

  .header {
    background: var(--white);
    padding: 24px;
    position: sticky;
    z-index: 3;
    top: 0;
  }

  @media screen and (max-width: 768px) {
    height: calc(100vh - 216px);
  }
`;

export const InfoTag = styled.div`
  border-radius: 8px;
  background: #fffae5;
  padding: 12px;
  margin: 24px 24px 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 450;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .resume-queue-btn {
    font-size: 14px;
    border-radius: 8px;
    font-weight: 450;
  }

  @media screen and (max-width: 768px) {
    .text-row {
      align-items: flex-start;
    }
  }
`;

export const SwitchButton = styled.div`
  display: flex;
  align-items: center;
  width: 30px;
  background-color: #fff; /* Inactive side color */
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border: 1px solid #032250;
  padding: 2px;

  &.active {
    background-color: var(--secondary); /* Active side color */
    justify-content: flex-end;
  }

  .slider {
    width: 12px;
    height: 12px;
    background-color: #032250;
    border-radius: 50%;
    transition: transform 0.3s ease;
  }

  &.active .slider {
    transform: translateX(1px);
  }
`;

export const StoryPreview = styled.div`
  max-width: 336px;
  padding: 24px 12px;
  aspect-ratio: 9 / 16;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  background-color: black;
  position: relative;
  overflow: hidden;
  border: 1px solid var(--grey_10);
  border-radius: 8px;
  box-shadow: var(--shadow);

  .storyMedia {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 90%;
    z-index: 1;
    filter: brightness(0.8);
    border-radius: 0 0 8px 8px;
    object-fit: cover;
  }

  .storyBottom {
    position: absolute;
    height: 10%;
    bottom: 0px;
    display: grid;
    grid-template-columns: 3fr 1fr;
    width: 100%;
    gap: 12px;
  }

  .storyInput {
    border: 1px solid var(--grey_10);
    border-radius: 48px;
    padding: 4px;
    height: 60%;
  }

  .storyHead {
    position: absolute;
    top: 10px;
    z-index: 2;
    width: 90%;
  }

  .progressBarContainer {
    // width: 100%;
    height: 2px;
    background-color: #e2e2ea;
    position: relative;
  }

  .progressBarFill {
    width: ${(props) => props.progress}%;
    height: 100%;
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    transition: width 1s linear;
    transition-delay: 1s;
    animation: ${keyframes`
    from {
      width: 0;
    }
    to {
      width: ${(props) => props.progress}%;
    }
  `} 5s linear;
  }

  .storyTime {
    margin-left: 3px;
    opacity: 50%;
  }
`;

export const ApprovalWorkflowWrapper = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background-color: #fff;
  border-left: 1px solid var(--grey_10);
  gap: 24px;

  .selectedWorkflowList {
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: auto;
    height: 100%;
  }

  .footerMain {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 12px;
    gap: 12px;
  }

  @media screen and (max-width: 768px) {
    position: fixed;
    height: 80%;
    z-index: 10;
    width: 90%;
    border: none;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05);
    border-radius: 12px;

    &::before {
      content: "";
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #fff;
      z-index: -1;
    }
  }
`;

export const ModalBackground = styled(Backdrop)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const HashtagManagerWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background-color: #fff;
  border-left: 1px solid var(--grey_10);
  gap: 24px;
  padding: 24px;
  position: relative;
`;
